import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import ProductDetailNavigationState from "@sonic/Store/Components/ProductDetailNavigation/ProductDetailNavigationState";
import { customerActions } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<ProductDetailNavigationState, DispatchProp<customerActions>>;

export const UpdateLinks: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductDetailNavigation/UpdateProductDetailNavigationState",
        parameter: props.parameter,
    });
};

export const SortLinks: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductDetailNavigation/SortProductDetailNavigationState",
        parameter: props.parameter,
    });
};

export const chain = [UpdateLinks, SortLinks];

const updateProductDetailNavigationState = createHandlerChainRunner(chain, "UpdateProductDetailNavigationState");
export default updateProductDetailNavigationState;
